import "./PrincipalDialog.scss";

export default {
  name: "PrincipalDialog",
  data: () => ({
    dialog: false,
    principalSearch: ""
  }),
  async mounted() {
    await this.$store.dispatch("getPrincipals");
    await this.$store.dispatch("getCurrentUser");
    if (!this.selectedPrincipal?.id) {
      this.dialog = true;
    }
  },
  computed: {
    selectedPrincipal: {
      get() {
        return this.$store.state.selectedPrincipal;
      },
      set(newValue) {
        return this.$store.dispatch("setSelectedPrincipal", newValue);
      }
    },
    principals() {
      if (this.principalSearch?.length) {
        return this.$store.state.principals.filter(p =>
          p.name.toLowerCase().includes(this.principalSearch.toLowerCase())
        );
      }
      return this.$store.state.principals ?? [{}];
    },
    user() {
      return this.$store.state.currentUser;
    },
    persistent() {
      return !this.selectedPrincipal?.id;
    }
  },
  methods: {
    selectPrincipal(principal) {
      this.selectedPrincipal = principal;
      this.dialog = false;
    },
    onClickOutside() {
      if (!this.selectedPrincipal?.id) {
        this.selectPrincipal(this.principals[0]);
      }
    },
    shouldCloseOnClickOutside(event) {
      if (event?.target?.closest(".principal_search")) {
        return false;
      }
      return !this.selectedPrincipal?.id;
    }
  }
};
